import * as React from 'react'
import Button from '@mui/material/Button'
import type { ClosingRequirementButtonProps } from './typings'

export function ClosingReqBtnSwitch(props: ClosingRequirementButtonProps) {
  const { entityId, isDisabled, requirement } = props

  switch (requirement) {
    case 'scheduling':
      return props.button

    case 'agreement':
    case 'payment':
    case 'service': {
      const { buttonText, buttonClick } = props

      return (
        <Button
          fullWidth
          size="small"
          variant="contained"
          onClick={buttonClick}
          disabled={isDisabled}
          data-test-id={`${requirement}Btn-${entityId}`}
        >
          {buttonText}
        </Button>
      )
    }
  }
}
